/* eslint-disable max-len */
import React from "react";

export const SortDownIcon: React.FC = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.664062" width="24" height="24" rx="3" fill="#DDE5E9"/>
      <path d="M19.3314 11.9997L18.1564 10.8247L13.498 15.4747V5.33301H11.8314V15.4747L7.18138 10.8163L5.99805 11.9997L12.6647 18.6663L19.3314 11.9997Z" fill="#2B3337"/>
    </svg>
  );
};
